module.exports = __webpack_public_path__ + "img/mobilia.fb52200b.png";